const version = process.env.REACT_APP_VERSION?.trim() || "0.0.0";
const suffix = process.env.REACT_APP_VERSION_SUFFIX?.trim() || "Ac-PROD";

function environmentLabel(value: string): string {
  const normalized = value.toUpperCase();
  if (normalized.endsWith("DEV")) return "DEV";
  if (normalized.endsWith("PROD")) return "PROD";
  return value;
}

/** Semántica X.Y.Z */
export const getAppVersion = (): string => version;

/** Etiqueta de entorno: DEV | PROD */
export const getEnvironmentLabel = (): string => environmentLabel(suffix);

/** Texto visible al usuario: "DEV 1.1.0" (homologado con app móvil) */
export const getAppVersionDisplay = (): string =>
  `${environmentLabel(suffix)} ${version}`;

/** Footer / login: "Versión: DEV 1.1.0" */
export const getAppVersionLabel = (): string =>
  `Versión: ${getAppVersionDisplay()}`;

/** Badge "Dev" solo cuando el sufijo indica entorno de desarrollo */
export const isDevEnvironment = (): boolean =>
  environmentLabel(suffix) === "DEV";
